/**
 * Does all around ads positioning
 */
var waAdSpace = {
	/**
	 * Does position the sidebar banner
	 * Does add image-responsive to specific ad formats
	 * Does hide ads position if no ad is delivered
	 */
	manageAdSpace: function () {
		if (typeof sas != "undefined") {
			// this._handleAdvertorialAds();
			// setTimeout(function () {
			this._handleSidebarAds();
			// }, 1000);
		}

		$(".ad-space")
			.imagesLoaded()
			.progress(function (instance, image) {
				$(image.img).addClass("img-responsive");
			});

		// NEW WAY SINCE 22 Feb 2023
		$(".ad-space").each(function () {
			var adElement = $(this);
			if (
				!adElement.children().length ||
				adElement.find(".ad-space-script").length > 0
			) {
				adElement.hide();
			}
		});

		// OLD WAY WHICH DOES NOT WORK ANYMORE SINCE 22 Feb 2023
		// Hide all ad spaces which do not deliver something
		// $('.ad-space').each(function() {
		// 	var adElement = $(this);
		// 	var scriptContent = adElement.find('script');
		//
		// 	if(scriptContent.context.clientHeight < 10 || !adElement.html()) {
		// 		adElement.hide();
		// 	}
		// });

		$(".ad-space-spacer-10").each(function () {
			if ($(this).css("display") !== "none") {
				if (this.clientHeight > 30) {
					$(this).addClass("m-b-5");
				} else {
					$(this).addClass("m-b-1");
				}
			}
		});

		$(".ad-space-spacer-5").each(function () {
			if ($(this).css("display") !== "none") {
				if (this.clientHeight > 30) {
					$(this).addClass("m-b-5");
				} else {
					$(this).addClass("m-b-1");
				}
			}
		});
	},
	/**
	 * calculates the needed card height for banners based on isotope grid items
	 * @param {array} elems
	 */
	calculateBannerCardHeight: function (
		element,
		elementHeight,
		largeHeight,
		mediumHeight
	) {
		if (typeof element !== "undefined" && element.length > 0) {
			$.each(element, function (i) {
				if (element[i].clientHeight > elementHeight) {
					$("#" + element[i].id).css("height", largeHeight + "px");
				}

				if (element[i].clientHeight < elementHeight) {
					$("#" + element[i].id).css("height", mediumHeight + "px");
				}

				if (element[i].clientHeight < 30) {
					element[i].remove();
				}
			});
		}

		console.log("calculated banner card height");
	},

	partnerLogos: function () {
		let partnerLogos = $("#sas_47285");
		if (partnerLogos.length !== 0) {
			if (partnerLogos[0].clientHeight < 10) {
				$("#partner-logos").hide();
			}
		}

		let botyPartnerLogos = $("#sas_54465");
		if (botyPartnerLogos.length !== 0) {
			if (botyPartnerLogos[0].clientHeight < 10) {
				$("#boty-partner-logos").hide();
			}
		}
	},

	_handleAdvertorialAds: function () {
		let advertorial = $("#sas_47262");

		if (
			typeof advertorial[0] !== "undefined" &&
			advertorial[0].clientHeight > 30
		) {
			let mediaQuery = window.matchMedia("(min-width: 1170px)");

			let mediaQueryEvent = function (mediaQuery) {
				advertorial.css(
					"height",
					mediaQuery.matches && advertorial[0].clientWidth > 500
						? "500px"
						: "300px"
				);
			};

			mediaQueryEvent(mediaQuery);
			mediaQuery.addListener(mediaQueryEvent);
		}
	},

	_handleSidebarAds: function () {
		let sidebar = $("#sidebar");

		if (typeof sidebar !== "undefined" && sidebar.length !== 0) {
			let bottomPadding = 0;

			let waFooter = $(".wa-footer");
			if (waFooter.length !== 0) {
				bottomPadding = waFooter.offset().top;
			}
			sidebar.affix({
				offset: {
					top: 100,
					bottom: bottomPadding,
				},
			});
		}

		// Check every 500ms for the #sas_47266 element
		let intervalId = setInterval(function () {
			let sideSpace2 = $("#sas_47266");

			if (sideSpace2.length !== 0) {
				// Check if element is loaded
				console.log(sideSpace2[0].clientHeight);

				if (sideSpace2[0].clientHeight > 30) {
					let content = $("#content");

					content.removeClass("col-md-12");
					content.addClass("col-md-10");

					let mediaQuery = window.matchMedia("(min-width: 1170px)");

					let mediaQueryEvent = function (mediaQuery) {
						let container = $(".container");

						container.css(
							"width",
							mediaQuery.matches ? "1404px" : "auto"
						);
					};

					mediaQueryEvent(mediaQuery);
					mediaQuery.addListener(mediaQueryEvent);
				} else {
					sideSpace2.hide();
				}

				clearInterval(intervalId); // Stop checking once element is found
			}
		}, 300); // Check every 500ms

		// Stop the interval after 5 seconds
		setTimeout(function () {
			clearInterval(intervalId); // Stop checking after 5 seconds
			console.log("Stopped checking after 5 seconds.");
		}, 5000);
	},
};
